import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import {ErrorBoundary} from 'react-error-boundary';
import ReactFlow, { useZoomPanHelper, useStore } from 'react-flow-renderer';
import '../../styling/Styles.css';
import PageFlowSideBar from './PageFlowSideBar';
import { CustomEdgeDown, CustomEdgeUp } from './CustomEdges';
import NoPageSelectedValidation from './NoPageSelectedValidation';
import initCanvas from './InitCanvas';
 
// This component renders all the required info of the nodes and the edges that represent a page flow diagramm.
const PageFlowCanvas = (props) => {
  const { selectedProject, selectedPage, loadPages } = props;

  const { setCenter } = useZoomPanHelper();
  const store = useStore();
  const [elements, setElements] = React.useState([]);
  const [initElements, setInitElements] = React.useState(false);
  const [reactflowInstance, setReactflowInstance] = useState(null);
  const [nodesWidth, setNodesWidth] = React.useState(0);
  const [nodesHeight, setNodesHeight] = React.useState(0);
  const { nodes } = store.getState();
  const colorFlows = ['#0C4D82', 'rgb(207, 216, 224)', 'pink'];

  const edgeTypes = {
    customDown: CustomEdgeDown,
    customUp: CustomEdgeUp
  };

  /*
    This useEffect is runned when we load a new page flow diagramm or when we change the dimensions of our monitor. It is responsible to
    render all the nodes and the edges of a page flow diagramm.
    */
  useEffect(() => {
    initCanvas(nodesWidth,nodesHeight,colorFlows,nodes,setElements,setInitElements);  
  }, [selectedPage, selectedProject, initElements, nodesWidth, nodesHeight,loadPages]);

  useEffect(() => {

    if ( nodes.length && reactflowInstance === true) {
      const node = nodes[0];
      const x = node.__rf.position.x + node.__rf.width / 2;
      const y = node.__rf.position.y + node.__rf.height * 2;

      setNodesHeight(node.__rf.height);
      setNodesWidth(node.__rf.width);

      const zoom = 1;
      setCenter(x, y, zoom);
      setInitElements(false);
    }
  }, [initElements,reactflowInstance]);

  useEffect(() => {
    const resizeListener = () => {
      setInitElements(true);
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);
    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  const onLoad = () => {
    setReactflowInstance(true);
  };
  
  const myErrorHandler = (error, info) => {
  
    throw Error(`Error in PageFlowCanvas.js that has been caught by Error Boundary${error}
    More info about this error: ${info}`);

  }

  return (
    <div
      className={clsx('blueBorderStyle', 'flexPropsDataCanvas')}
      style={{ backgroundColor: 'white', flexDirection: 'row' }}
    >
      <div
        style={{
          height: 'auto',
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          overflowY: 'auto'
        }}
      >
        {selectedPage > -1 && selectedProject > -1 ? (
          
          <ErrorBoundary onError={myErrorHandler}>
            <ReactFlow
              elements={elements}
              elementsSelectable={false}
              nodesConnectable={false}
              nodesDraggable
              zoomOnScroll={false}
              panOnScroll={false}
              panOnScrollMode={false}
              zoomOnDoubleClick={false}
              onConnect={false}
              onLoad={onLoad}
              onElementClick={false}
              onNodeDragStart={undefined}
              onNodeDragStop={undefined}
              paneMoveable={false}
              onPaneClick={undefined}
              onPaneScroll={undefined}
              onPaneContextMenu={undefined}
              defaultZoom={1}
              edgeTypes={edgeTypes}
              minZoom={1}
              maxZoom={1}
              snapToGrid
            >
              <PageFlowSideBar colorFlows={colorFlows} />
            </ReactFlow>
          </ErrorBoundary>

        ) : (
          <NoPageSelectedValidation />
        )}
      </div>
    </div>
  );
};

export default PageFlowCanvas;
